import {OwayoZoomInfoObject} from "../OwayoJsViewer";
import {THREE} from "../resource/three.js";
import {EventVerteiler} from "../../global/eventVerteiler";
import {valuesAreEqualWithinPrecision} from "../../global/globalUtils";
import globalsObject from "../globalsObject";
import {CONSTANTS} from "../meta_data";
import {Vector2} from "../delme_globals";
import {VIEWERFEATURE} from "../debugMenu";

export class ViewerZoomController {
    public zoom! : OwayoZoomInfoObject;
    private origFieldOfView;
    private camera:THREE.PerspectiveCamera;

    setCamera = (camera:THREE.PerspectiveCamera)=>{
        this.camera = camera;
        this.origFieldOfView = camera.fov;
        this.zoom = new OwayoZoomInfoObject();
    }

    maxZoomReached = ()=>EventVerteiler.broadcast("maxZoomReachedEvent");
    minZoomReached = ()=>EventVerteiler.broadcast("minZoomReachedEvent");
    zoomLevelChanged = ()=>EventVerteiler.broadcast("zoomLevelChangedEvent");
    public getFactor = ()=>this.zoom.factor;
    public getZoomOrigin = ()=>this.zoom.origin;

    public stopZooming() {
        this.zoom.ongoing = false;
        this.zoom.startFactor = null;
    }

    public zoomIn(mouseCoordinate?, ongoing?, targetZoomFactor?)
    {
        const offset = globalsObject.owayoJSViewer.getContainerOffset();
        let newPoint, deltaX, deltaY;

        if (typeof(targetZoomFactor) === "undefined") {
            this.zoom.factor = this.zoom.factor * 1.1 ;
            if ( this.zoom.factor >= CONSTANTS.MAX_ZOOM && ViewerZoomController.maxZoomIsLimited() ) {
                this.zoom.factor = CONSTANTS.MAX_ZOOM;
                this.maxZoomReached();
            } else {
                this.zoomLevelChanged();
            }
        } else {
            this.zoom.factor = targetZoomFactor;
        }
        // GetMousePositionInCanvas
        if (!this.zoom.ongoing && typeof(mouseCoordinate) !== "undefined") {
            this.zoom.target = globalsObject.owayoJSViewer.get3DCoordinateAtZeq0({x:mouseCoordinate.x - offset.left, y:mouseCoordinate.y - offset.top});
        }

        // Zoom
        this.camera.fov = this.origFieldOfView / this.zoom.factor;
        this.camera.updateProjectionMatrix();
        if ( typeof(mouseCoordinate) !== "undefined") {
            newPoint = globalsObject.owayoJSViewer.get3DCoordinateAtZeq0({x:mouseCoordinate.x - offset.left, y:mouseCoordinate.y - offset.top});
            deltaX = this.zoom.target.x - newPoint.x;
            deltaY = this.zoom.target.y - newPoint.y;

            this.camera.position.x += deltaX;
            this.camera.position.y += deltaY;
        }

        globalsObject.owayoJSViewer.doRender();
        this.zoom.ongoing = ongoing; //wurde von aufrufender Funktion übergeben
    }

    private static maxZoomIsLimited = ()=>!VIEWERFEATURE.EDIT_MATERIALS

    zoomOut(mouseCoordinate?, ongoing?, targetZoomFactor?)
    {
        const offset = globalsObject.owayoJSViewer.getContainerOffset(),
            oldZoom = this.zoom.factor;

        if (typeof(targetZoomFactor) === "undefined") {
            this.zoom.factor = this.zoom.factor / 1.1;
        } else {
            this.zoom.factor = targetZoomFactor;
        }
        if (oldZoom === this.zoom.factor) {
            return;
        }
        if (this.zoom.factor <= CONSTANTS.MIN_ZOOM) {
            this.minZoomReached();
            this.zoom.factor = CONSTANTS.MIN_ZOOM;
        } else {
            this.zoomLevelChanged();
        }
        if (oldZoom === this.zoom.factor) {
            return;
        }
        if (this.zoom.factor === 1) {
            globalsObject.owayoJSViewer.moveCameraToPosition(this.zoom.origin.x,this.zoom.origin.y,this.camera.position.z, 0.5);
        } else {
            if (!this.zoom.ongoing && typeof(mouseCoordinate) !== "undefined") {
                this.zoom.target = globalsObject.owayoJSViewer.get3DCoordinateAtZeq0({x:mouseCoordinate.x - offset.left, y:mouseCoordinate.y - offset.top});
            }
        }

        this.camera.fov = this.origFieldOfView / this.zoom.factor;
        this.camera.updateProjectionMatrix();
        globalsObject.owayoJSViewer.doRender();
        this.zoom.ongoing = ongoing; //wurde von aufrufender Funktion übergeben //FIXME die Funktion wird aber auch ohne diesen Parameter übergeben

        globalsObject.owayoJSViewer.doRender();
    }

    public setZoomLevel(targetZoom) {
        this.zoom.factor = targetZoom;//Math.pow(1.1, targetZoom - 1);
        this.camera.fov = this.origFieldOfView / this.zoom.factor;
        this.camera.updateProjectionMatrix();
        globalsObject.owayoJSViewer.calcViewSize();
    }

    public handlePinch(event) {

        if (this.zoom.startFactor === null) {
            this.zoom.startFactor = this.zoom.factor;
        }
        let newZoom = this.zoom.startFactor * event.scale;
        newZoom = Math.max(newZoom, CONSTANTS.MIN_ZOOM);
        newZoom = Math.min(newZoom, CONSTANTS.MAX_ZOOM);
        if (valuesAreEqualWithinPrecision(newZoom, this.zoom.factor)) {
            return;
        }
        if (newZoom > 1) {
            this.zoomIn(event.center, true, newZoom);
        } else {
            this.zoomOut(event.center, true, newZoom);
        }
    }

    public zoomOnMouseWheel(adjustedAmountFromEvent, targetFromEvent:Vector2) {
        if(adjustedAmountFromEvent < 0) {
            this.zoomOutSteps(Math.abs(adjustedAmountFromEvent), targetFromEvent);
        } else {
            this.zoomInSteps(adjustedAmountFromEvent, targetFromEvent);
        }
    }

    private zoomOutSteps(steps, targetFromEvent) {
        for (let i = 0; i < steps; i = i + 1) {
            if (this.zoom.factor <= CONSTANTS.MIN_ZOOM) {
                return;
            }
            this.zoomOut(targetFromEvent, false);
        }
    }

    private zoomInSteps(steps, targetFromEvent) {
        for (let i = 0; i < steps; i = i + 1) {
            if (this.zoom.factor >= CONSTANTS.MAX_ZOOM && ViewerZoomController.maxZoomIsLimited()) {
                return;
            }
            this.zoomIn(targetFromEvent);
        }
    }

    public resetZoomLevel = ()=>this.setZoomLevel(1);
    public currentSnapRange = ()=>Math.round(CONSTANTS.BASE_COORD_SNAP + 6 - CONSTANTS.SNAP_ZOOM_DECREASE * this.getFactor());
    getTarget = ()=>this.zoom.target;
    setOrigin = origin=>this.zoom.origin = origin;
    setTarget = target=>this.zoom.target = target;

    public currentAngleSnapRange() {
        return Math.round(
            (CONSTANTS.ANGLE_ANCHOR_SNAP * (this.zoom.factor + CONSTANTS.MIN_ZOOM - CONSTANTS.MAX_ZOOM - 1) - this.getFactor() + 1)
            / ( CONSTANTS.MIN_ZOOM - CONSTANTS.MAX_ZOOM)
        );
    }
}
